import React from 'react'
import moment from 'moment'

import BookingSchedule from '../../../care-enrolments/details/ccs-gov-enrolments/booking-schedules/views'
import { groupBookingsByWeek } from '../../../care-enrolments/details/ccs-gov-enrolments/booking-schedules/helper'

export const extractSessions = record => {
  const defaultReturnedValue = { results: [] }

  if (!record['gov_record']) return defaultReturnedValue
  if (!record['gov_record']['SessionOfCares']) return defaultReturnedValue

  const foundSessions = record['gov_record']['SessionOfCares']['results']

  return Array.isArray(foundSessions) && foundSessions.length > 0
    ? {
        results: foundSessions.map(e => ({
          endTime: e.endTime,
          startTime: e.startTime,
          hoursInCasualSession: e.hoursInCasualSession,
          sessionType: e.sessionType,
          sessionUnitOfMeasure: e.sessionUnitOfMeasure,
          cycleWeekNumber: '1',
          sessionDay: moment(e.date || new Date())
            .isoWeekday()
            .toString(),
          standardAmount: e.amountCharged,
          isChildAbsent: e.isChildAbsent,
          message: sessionMessage(e),
          pillTitle: e.isChildAbsent ? 'Child was absent for this session' : undefined,
        })),
      }
    : defaultReturnedValue
}

const shouldShowWarning = session => session.isChildAbsent

const sessionMessage = session => {
  const preschoolMessage =
    session.isPreSchoolProgram && session.isPreSchoolProgram.toUpperCase() === 'Y'
      ? 'Preschool'
      : undefined

  const absenceMessage = session.absenceReason ? 'Additional Absence' : undefined

  return [preschoolMessage, absenceMessage].join(' ')
}

const DisplayWeeklySessions = ({ sessions }) => {
  if (!sessions.results) {
    return null
  }

  const { week1 } = groupBookingsByWeek(sessions.results)

  if (week1.length === 0) {
    return null
  }

  return <BookingSchedule compact week1={week1} week2={false} showWarningFun={shouldShowWarning} />
}

export default DisplayWeeklySessions



// WEBPACK FOOTER //
// ./src/session-summaries/details/views/display-sessions.jsx